import {get, reduce} from 'lodash';
import {Action} from 'redux';

import {GET_INFO} from '/redux/action/currentUser.action';

const actionSanitizer = <A extends Action>(action: A): A => {
  if (action.type === GET_INFO) {
    return {
      ...action,
      payload: {
        ...get(action, 'payload', {}),
        coach: '[Coach]',
      },
    };
  }
  return action;
};

const stateSanitizer = (state: any) => {
  return {
    ...state,
    coach: {
      ...get(state, 'coach', {}),
      allProfiles: reduce(
        get(state, 'coach.allProfiles', []),
        (result, value, key) => ({
          ...result,
          [key]: '[Coach]',
        }),
        {},
      ),
    },
  };
};

export default {
  actionSanitizer,
  stateSanitizer,
};
